import { getEvLoans } from "../../../apis/evLoans";
import { roundEvAmount } from "../ev-loans/evLoanFormatting";

export async function getEvAccountingRows(account, startDate, endDate) {
  const user = JSON.parse(sessionStorage.getItem("info") || "{}");
  if (!["financer", "retailer", "employee"].includes(user.type)) return [];
  const response = await getEvLoans();
  const loans = response?.data || [];
  const rows = [];
  const inRange = (date) => (!startDate || date >= startDate) && (!endDate || date <= endDate);
  const matchesAccount = (mode) => mode === account || (account === "bank" && mode === "upi");

  loans.forEach((loan) => {
    const loanAccount = loan.loan_account_number || `VasudevEV${String(loan.id).padStart(6, "0")}`;
    const customerName = loan.customer?.full_name || "EV customer";
    const charges = roundEvAmount(Number(loan.processing_charges || 0) +
      Number(loan.file_charges || 0) + Number(loan.other_charges || 0));
    if (["disbursed", "closed"].includes(loan.status) && loan.disbursement_date && inRange(loan.disbursement_date) &&
        matchesAccount(loan.disbursement_mode)) {
      rows.push({
        id: `ev-disbursement-${loan.id}`,
        date: loan.disbursement_date,
        Name: `EV loan disbursement - ${loanAccount}`,
        address: `${customerName}; dealer ${loan.dealer_details?.name || "—"}; ${loan.dealer_details?.bank_name || ""} account ${loan.dealer_details?.account_number || ""}; gross ${roundEvAmount(loan.principal)}; charges collected separately ${charges}; net ${roundEvAmount(loan.principal)}`,
        amount: roundEvAmount(loan.principal),
        cash_bank: loan.disbursement_mode,
        type: "EV loan disbursement",
        direction: "Debit",
      });
    }
    if (charges > 0 && loan.charges_payment_date && inRange(loan.charges_payment_date) &&
        matchesAccount(loan.charges_payment_mode)) {
      rows.push({
        id: `ev-charges-${loan.id}`,
        date: loan.charges_payment_date,
        Name: `EV loan charges collected - ${loanAccount}`,
        address: `${customerName}; processing ${roundEvAmount(loan.processing_charges)}; file ${roundEvAmount(loan.file_charges)}; other ${roundEvAmount(loan.other_charges)}${loan.charges_payment_reference ? `; receipt ${loan.charges_payment_reference}` : ""}`,
        amount: charges,
        cash_bank: loan.charges_payment_mode,
        type: "EV loan charges collected",
        direction: "Credit",
      });
    }
    (loan.payments || []).forEach((payment) => {
      if (!inRange(payment.payment_date) || !matchesAccount(payment.payment_mode)) return;
      rows.push({
        id: `ev-payment-${payment.id}`,
        date: payment.payment_date,
        Name: `EV EMI collection - ${loanAccount}`,
        address: `${customerName}; receipt ${payment.reference}`,
        amount: roundEvAmount(payment.amount),
        cash_bank: payment.payment_mode,
        type: "EV EMI collection",
        direction: "Credit",
      });
    });
  });
  return rows;
}
